import { apartmentsReducer } from "./apartments/apartmentsReducer";
import { brandsMetersReducer } from "./brands/brandsMetersReducer";
import { capturesReducer } from "./captures/capturesReducer";
import { collectPeriodsReducer } from "./collectPeriods/collectPeriodsReducer";
import { facilitiesReducer } from "./facilities/facilitiesReducer";
import { metersReducer } from "./meters/metersReducer";
import { notesReducer } from "./notes/notesReducer";
import { paymentsReducer } from "./payments/paymentsReducer";
import { routeCyclesReducer } from "./routeCycles/routeCyclesReducer";
import { routesReducer } from "./routes/RoutesReducer";

export const buildingsReducers = {
  apartments: apartmentsReducer,
  brandsMeters: brandsMetersReducer,
  captures: capturesReducer,
  collectPeriods: collectPeriodsReducer,
  facilities: facilitiesReducer,
  meters: metersReducer,
  notesBuildings: notesReducer,
  routesBuildings: routesReducer,
  routeCycles: routeCyclesReducer,
  payments: paymentsReducer
};
